import React from "react"
import ContentHeader from "shared/ContentHeader"
import RelatedFormSubmissions from "./RelatedFormSubmissions"
import SurveyDetails from "./SurveyDetails"

export const SUPPLEMENTAL_TAB_ID = "tab-supplemental"
export const SUPPLEMENTAL_TAB_PANEL_ID = "tabpanel-supplemental"

const SupplementalContent = () => (
  <div id={SUPPLEMENTAL_TAB_PANEL_ID} className="relative grow" role="tabpanel" aria-labelledby={SUPPLEMENTAL_TAB_ID}>
    <div className="inner-container mx-auto max-w-screen-lg">
      <ContentHeader
        heading={<h1 className="text-center header-title !mb-3">Supplemental</h1>}
      />
      <SurveyDetails className="mb-16" />
      <RelatedFormSubmissions />
    </div>
  </div>
)

export default SupplementalContent
